<template>
  <aw-sf-recommendation
    page="home"
    :bordered="isOnWhiteCard"
    :analytics-banner-interaction="analyticsBannerInteraction"
    :analytics-measurable="analyticsMeasurable"
  />
</template>

<script setup>
  import cmsPageComponentMixin from '~~/common/mixins/cmsPageComponentMixin.js';
  import AwSfRecommendation from '~~/common/components/Common/AwSfRecommendation.vue';
  import analyticsBannerInteractionMixin from '~~/common/mixins/analyticsBannerInteractionMixin';

  defineProps({
    ...cmsPageComponentMixin.props,
    ...analyticsBannerInteractionMixin.props,
    content: {
      type: Object,
      required: true,
    },
  });
</script>
